export const getYearOptions = () => {
  const start = new Date().getFullYear();
  const end = 2023;
  return Array.from({ length: start - end + 1 }, (_, k) => ({
    label: `${start - k} (UTC)`,
    value: `${start - k}`,
  }));
};
